// extracted by mini-css-extract-plugin
export default {"cart-item":"CartItem_cart-item__5Zalx","summary":"CartItem_summary__mFnXH","price":"CartItem_price__UB0Fs","amount":"CartItem_amount__2iQQn","actions":"CartItem_actions__stNUc"};